/**
 * Created by fers on 27.04.16.
 */
import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';

import {displayError} from '../../app/errorDisplayer';
import DataSourceDecoration from './DataSourceDecorationAdd.react';
import LoadingButton from '../../fw/LoadingButton.react';
import {FormattedMessage, injectIntl, defineMessages} from 'react-intl';
import {LoadingLine} from '../../loadingLine/renderLoadingPanel.react';
import types from '../../../common/model-api/types';
import GridList from '../../fw/GridList.react';
import * as Tool from '../../fw/Tool';
import {supportedTypes} from '../../../common/fw/MetaDataHelper';
import ExpressionEditor from './SearchActionExpressionEditor.react';
import DataSourceSearchActionEdit from './DataSourceSearchActionEdit.react';
import {prepareArgs} from './DataSourceSearchActionEdit.react';

export const handlerName = "search-action";
export const config = DataSourceSearchActionEdit;

export const messages = defineMessages({
    textarea: {id: 'DataSourceManualQueryAdd.textarea', 'defaultMessage': 'DatiQuery'},
});

class DataSourceSearchActionAdd extends React.Component {

    static propTypes = {
        apply: PropTypes.func,
        dataSource: PropTypes.object,
        dataSourceToAdd: PropTypes.object,
        goBack: PropTypes.func,
        intl: PropTypes.object.isRequired,
        relay: PropTypes.object,
    };

    constructor(props) {
        super(props);

        this.mapping = {};
    }

    add = (mapping) => {
        let channel = this.props.dataSource.screen.organisation.channel;
        let channelDef = channel.channelDef;
        let actionDef = channelDef.actionDef;
        let sourceDef = actionDef.sourceDef;
        let channelEntityDef = sourceDef.channelEntityDefs.edges[0].node;

        let newDataSource = {
            ...this.props.dataSourceToAdd,
            channel_id: channel.realId,
            channelDef_id: channelDef.realId,
            sourceDef_id: sourceDef.realId,
            entityDef_id: channelEntityDef.entityDef_id,
            args: {
                actionDef_id: actionDef.realId,
                ...prepareArgs(actionDef, mapping),
            }
        };

        return this.props.apply(newDataSource);
    };

    componentWillReceiveProps = (props) => {
        let channel = props.dataSource.screen.organisation.channel;

        if (channel) {
            let channelDef = channel.channelDef;

            if (channelDef) {
                let actionDef = channelDef.actionDef;

                /* try to create default mapping instead of user */
                if (actionDef && (!this.actionDefId || actionDef.realId !== this.actionDefId)) {
                    this.actionDefId = actionDef.realId;

                    let newMapping = {};
                    let hasChange = false;

                    for (let {node: actionInputDef} of actionDef.actionInputDefs.edges) {
                        for (let field of props.dataSource.mappedFields) {
                            let key = actionInputDef.key;
                            if (actionInputDef.fieldDef_id) {
                                key = actionInputDef.fieldDef_id;
                            }

                            if (field.realId === actionInputDef.fieldDef_id) {
                                newMapping[key] = "${" + field.realId + "}";
                                hasChange = true;
                                break;

                            /* if mapping was not assigned yet, and type is specific enough, we will offer mapping */
                            } else if (!newMapping[key] &&
                                field.type === actionInputDef.type &&
                                supportedTypes[field.type] &&
                                supportedTypes[field.type].isDataSpecific === true) {
                                newMapping[key] = "${" + field.realId + "}";
                                hasChange = true;
                                break;
                            }
                        }
                    }

                    if (hasChange) {
                        this.mapping = newMapping;
                    }
                }
            }
        }
    };

    render() {
        let dataSourceToAdd = this.props.dataSourceToAdd;
        let dataSource = this.props.dataSource;

        let type = types['channels'];

        let isShowingChannel = this.props.relay.variables.channel_id ? true : false;
        let isShowingActionDef = this.props.relay.variables.actionDef_id ? true : false;

        let content = <LoadingLine/>;

        if (dataSource && dataSource.screen && dataSource.screen.organisation) {
            if (isShowingActionDef && dataSource.screen.organisation.channel.channelDef.actionDef) {

                let actionDef = dataSource.screen.organisation.channel.channelDef.actionDef;

                content = (
                    <div style={{width: '100%', paddingBottom: '15em'}}>

                        <h3>{actionDef.name}</h3>
                        {actionDef.description ? <p>{actionDef.description}</p> : null}
                        {actionDef.sourceDef ? <span><FormattedMessage defaultMessage="Returns {name}." id="DataSourceSearchAction.actionDef.returns" values={{name: actionDef.sourceDef.name}} /></span> : null}

                        <ExpressionEditor actionDef={dataSource.screen.organisation.channel.channelDef.actionDef} dataSource={dataSourceToAdd} intl={this.props.intl} mapping={this.mapping} parentDataSource={dataSource} save={this.add} />
                    </div>
                );
            } else if (isShowingChannel && dataSource.screen.organisation.channel) {
                content = (
                    <div>
                        <FormattedMessage defaultMessage="Choose search action:"
                                          id="DataSourceSearchAction.chooseActionDef"/><br/>

                        <div
                            className="btn-group-vertical DataSourceRelationGroup">{dataSource.screen.organisation.channel.channelDef.searchActionDefs.edges.map((node, idx) => {
                                let actionDef = node.node;
                                return (
                                    <LoadingButton className="btn btn-default" key={idx}
                                                   onClick={() => {
                                                       this.props.relay.setVariables({
                                                           "selectedActionDef": true,
                                                           "actionDef_id": actionDef.id
                                                       });
                                                   }}>
                                        <span aria-hidden="true" className="fa fa-plus fa-fw"></span>{" "}{actionDef.name ? actionDef.name : (Tool.getFormatted(types['actionDefs'], 'operation', this.props.intl.formatMessage, actionDef) + (actionDef.sourceDef && actionDef.sourceDef.name ? " " + actionDef.sourceDef.name : ""))}
                                    </LoadingButton>
                                );
                            })}
                        </div>
                    </div>
                );
            } else if (!isShowingChannel && !isShowingActionDef && dataSource.screen.organisation.channels) {
                content = (
                    <div>
                        <div className="sectionHeader">
                            <h3><FormattedMessage defaultMessage="Choose connected application:" id="DataSourceQuery.chooseApplication.description"/><br/></h3>
                        </div>

                        <GridList
                            bothTitles
                            edges={dataSource.screen.organisation.channels}
                            iconProperty="channelDef.icon"
                            metadata={type}
                            onClick={(item, event) => {
                                this.props.relay.setVariables({
                                    "selectedChannel": true,
                                    "channel_id": item.id
                                });
                            }}
                            relay={this.props.relay}
                            titleProperty="name"
                            titleProperty2="channelDef.name"
                        />
                    </div>
                );
            }
        }

        try {
            return (
                <DataSourceDecoration
                    dataSource={dataSource}
                    dataSourceToAdd={dataSourceToAdd}
                    goBack={this.props.goBack}
                >

                    <div style={{padding: '2em'}}>
                        {content}
                    </div>
                </DataSourceDecoration>
            );
        } catch (e) {
            displayError(e);
            return (<div>Error</div>);
        }
    }
}


export default Relay.createContainer(injectIntl(DataSourceSearchActionAdd), {
    initialVariables: {
        selectedChannel: false,
        channel_id: null,
        selectedActionDef: false,
        actionDef_id: null,
    },
    prepareVariables (variables) {
        return variables;
    },
    fragments: {
        dataSource: () => {
            return Relay.QL`
                fragment on DataSource {
                    id,
                    realId,
                    channelDefs {
                        id,
                        name,
                        icon,
                    },
                    mappedFields {
                        id,
                        realId,
                        name,
                        key,
                        type,
                        shortName,
                        entityDef {
                            id,
                            realId,
                            name,
                            key
                        }
                    },
                    screen {
                        id,
                        organisation {
                            id,
                            channel(id: $channel_id) @include(if: $selectedChannel) {
                                id,
                                realId,
                                channelDef {
                                    id,
                                    realId,
                                    name,
                                    actionDef(id: $actionDef_id) @include(if: $selectedActionDef) {
                                        id,
                                        realId,
                                        name,
                                        sourceDef {
                                            id,
                                            realId,
                                            name,
                                            channelEntityDefs(first: 100) {
                                                edges {
                                                    node {
                                                        id,
                                                        entityDef_id,
                                                        entityDef {
                                                            id,
                                                            name,
                                                        }
                                                    }
                                                }
                                            }
                                        }, 
                                        actionInputDefs(first: 1000) {
                                            edges {
                                                node {
                                                    id,
                                                    realId,
                                                    key,
                                                    name,
                                                    type,
                                                    entityDef_id,
                                                    fieldDef_id,
                                                    entityDef {
                                                        id,
                                                        name,
                                                    },
                                                    fieldDef {
                                                        id,
                                                        name
                                                    }
                                                }
                                            }
                                        }
                                    },
                                    searchActionDefs(first: 1000) {
                                        edges {
                                            node {
                                                id,
                                                realId,
                                                name,
                                                operation,
                                                sourceDef {
                                                    id,
                                                    name,
                                                }
                                            }
                                        }
                                    }
                                },
                            },
                            channels(first: 100, deleted: false) {
                                edges {
                                    node {
                                        id,
                                        realId,
                                        organisation_id,
                                        name,
                                        channelDef {
                                            id,
                                            name,
                                            icon,
                                        }
                                    }
                                }
                            }
                        }
                    }
                }`;
        }
    }
});
